<template>
  <header class="haeder-bar">
    <!-- header area start -->
    <div class="header-area">
      <div class="container">
        <div class="row">
          <!-- logo start -->
          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3" style="position: relative">
            <div class="header-logo">
              <router-link to="/index"><img src="../assets/picture/logo-1.png" alt="logo" class="img-fluid" />
              </router-link>
            </div>
            <div :class="isActive ? 'menu-btn is-active' : 'menu-btn'" @click="muneClick">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </div>
          <!-- main menu area start -->
          <div class="col-xl-10 col-lg-10 col-md-10 col-sm-9">
            <div class="header-top-right float-right">
              <div class="header-top-btn">
                <a @click="download" class="btn btn-type-1">下载
                  <i class="fa fa-download"></i></a>
              </div>
            </div>
            <div class="main-menu-area float-right">
              <div :class="isActive ? 'main-menu' : 'main-menu hiden-menu'">
                <nav>
                  <ul>
                    <li :class="routePath == '/index' ? 'active' : ''">
                      <a @click.prevent="routerGo('/index')">首页</a>
                    </li>
                    <li :class="routePath == '/about' ? 'active' : ''">
                      <a @click.prevent="routerGo('/about')">关于</a>
                    </li>
                    <li :class="routePath == '/features' ? 'active' : ''">
                      <a @click.prevent="routerGo('/features')">软件介绍</a>
                    </li>
                    <li class="sub-menu-li" @click="suMenuClick()">
                      <a href="#">
                        <span>APP相关</span>
                        <i class="fa fa-angle-down"></i></a>
                      <ul :class="showSubMenu ? 'sub-menu text-left show-sub-menu': 'sub-menu text-left'">
                        <li :class="routePath == '/privacy_protocol' ? 'active' : ''">
                          <!-- <a @click.prevent="routerGoAlabel('https://xinyucp.cn:5001/protocol/privacy_protocol')">隐私协议</a> -->
                          <a
                              href="https://xinyucp.com/home/protocol/privacy_protocol"
                              tag="a"
                              target="_blank"
                          >隐私协议</a>
                        </li>
                        <li :class="routePath == '/user_protocol' ? 'active' : ''">
                          <!-- <a @click.prevent="routerGoAlabel('https://miyustar.com/protocol/myxq_perms.html')">权限声明</a> -->
                          <a
                              href="https://xinyucp.com/home/protocol/user_protocol"
                              tag="a"
                              target="_blank"
                          >用户协议</a>
                        </li>
                      </ul>
                      <div class="sub-menu-btn">
                        {{ showSubMenu ? "-" : "+" }}
                      </div>
                    </li>
                    <li :class="routePath == '/contact' ? 'active' : ''">
                      <a @click.prevent="routerGo('/contact')">联系我们</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      isActive: false,
      showSubMenu: false,
      code: ''
    };
  },
  created() { },
  mounted() {
    if(this.$route.query.code){
      this.code = this.$route.query.code
    }
  },
  methods: {
    muneClick() {
      this.isActive = !this.isActive;
    },
    suMenuClick(ev) {
      console.log(123);
      this.showSubMenu = !this.showSubMenu;
    },
    routerGo(path) {
      this.$router.push(path);
      this.isActive = false;
      this.showSubMenu = false;
    },
    routerGoAlabel(path) {
      location.href = path;
      this.isActive = false;
      this.showSubMenu = false;
    },
    download(){
      try {
        this.$copyText(this.code)
      }catch (err) {
        console.log("err:", err)
      }
      location.href = 'https://www.xinyucp.cn/downloads/jiaojiaowo.apk';
    },
  },
  computed: {
    routePath() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="less" scoped>
.haeder-bar {
  position: sticky;
  top: 0;
  z-index: 9999;
  background: #fff;
  border-bottom: 1px solid #d2c8c8;
}

.main-menu {
  ul {
    li {
      cursor: pointer;

      &:hover {
        color: #ff60a3;
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .main-menu-area {
    float: none !important;

    .main-menu {
      transition: all 0.5s ease-in-out;
      max-height: 400px;
      overflow: hidden;

      ul {
        display: block;

        li {
          display: block;
          text-align: left;

          a {
            padding: 10px;
          }
        }

        .sub-menu-li {
          .sub-menu {
            position: static;
            opacity: 1;
            width: 100%;
            max-height: 0;
            overflow: hidden;
          }

          .show-sub-menu {
            max-height: 100px;
            visibility: visible;
            transform: scaleY(1);
          }
        }
      }

      .sub-menu-btn {
        font-size: 18px;
        border: 1px solid #212529;
        color: #212529;
        font-weight: 700;
        height: 27px;
        margin-top: 1px;
        position: absolute;
        right: 0;
        text-align: center;
        top: 0;
        width: 26px;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .hiden-menu {
      max-height: 0;
      overflow: hidden;
    }
  }

  .menu-btn {
    width: 40px;
    height: 40px;
    border: 1px solid #444;
    cursor: pointer;
    padding: 8px;
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);

    .line {
      background: #444;
      height: 3px;
      width: 22px;
      margin-top: 3px;
      transition: all 0.5s ease-in-out;
    }
  }

  .is-active {
    .line {
      &:nth-child(1) {
        transform: translateY(6px) rotate(45deg) scale(1.2);
      }

      &:nth-child(2) {
        visibility: hidden;
      }

      &:nth-child(3) {
        transform: translateY(-6px) rotate(135deg) scale(1.2);
      }
    }
  }
}

@media screen and (min-width: 576px) {

  .menu-btn,
  .sub-menu-btn {
    display: none;
  }
}
</style>